module.exports = __webpack_public_path__ + "static/cocktails1-584f89b3311cfeeecdcf17851b191af3.png";